<div class="toolbar w-full flex flex-col lg:flex-row">
  <div 
    class="button-wrapper" 
    *ngFor="let tile of tiles()"
  >
    <!-- remove styles from stylesheet to allow for different inline styles -->
    @if (layout() === 'row') {
      <div 
        class="buttons items-end"
        (click)="onClick(tile)"
        (keydown.enter)="onClick(tile)"
        tabindex="0"
      >
        <lib-icon [icon]="tile.iconName ?? ''" class="icon"></lib-icon>
        <h2>{{ tile.data }}</h2>
        <p class="bold">{{ tile.label }}</p>
      </div>
    } @else if(layout() === 'column') {
      <div 
        class="buttons"
        (click)="onClick(tile)"
        (keydown.enter)="onClick(tile)"
        tabindex="0"
      >
        <lib-icon [icon]="tile.iconName ?? ''" class="icon"></lib-icon>
        <div class="items-center flex-col">
          <p class="bold">{{ tile.label }}</p>
          <p>{{ tile.data }}</p>
        </div>
      </div>
    }
  </div>
</div>